export default __webpack_public_path__ + "static/media/STLCoverLetterforEarningsCall.5ff1d250.pdf";